import { DatePipe, Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  Injector,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { ActivatedRoute } from '@angular/router';
import {
  ModuleName,
  Modules,
  NotificationTextMessage,
  RoutingPath,
} from '@app/core/Enum';
import { ProductDetailsModel, RecurringModule } from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import {
  CreateRecurringModule,
  GetDataByRecurringModuleId,
  GetRecurringNumber,
  MenuState,
} from '@app/core/Store';
import {
  AddRecurringModuleComponent,
  ProductDetailsComponent,
} from '@app/modules';
import { AddClosePopupComponent } from '@app/modules/common';
import { Select, Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-recurring-module',
  templateUrl: './recurring-module.component.html',
  styleUrls: ['./recurring-module.component.scss'],
})
export class RecurringModuleComponent implements OnInit {
  isShowSideListAction = false;
  istoggleSideList = false;
  isExpandAll = false;

  recurringId = Guid.EMPTY as unknown as Guid;
  invoiceId = Guid.EMPTY as unknown as Guid;

  amount = 0;
  balanceAmount = 0;
  moduleId = 0;
  moduleName = '';

  recurringData: RecurringModule;
  productItems: Array<ProductDetailsModel>;

  @Output()
  readonly reloadSideList = new EventEmitter<any>();
  @ViewChild(MatAccordion) accordion: MatAccordion;

  triggerEditData: Subject<any> = new Subject<any>();

  @ViewChild(AddRecurringModuleComponent, { static: true })
  recurringDetails;

  @ViewChild(ProductDetailsComponent, { static: true })
  productDetails;

  @Select(MenuState.moduleId)
  moduleId$: Observable<number>;

  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;

  triggereEditProductData: Subject<any> = new Subject<any>();

  subscriptionRouting: Subscription;
  module = Modules;

  _Activatedroute: ActivatedRoute;
  store: Store;
  commonService: CommonService;
  dialog: MatDialog;
  spinner: NgxSpinnerService;
  datepipe: DatePipe;
  location: Location;
  renderer: Renderer2;
  commonNotificationText = NotificationTextMessage;
  constructor(private injector: Injector) {
    this._Activatedroute = injector.get<ActivatedRoute>(ActivatedRoute);
    this.store = injector.get<Store>(Store);
    this.commonService = injector.get<CommonService>(CommonService);
    this.dialog = injector.get<MatDialog>(MatDialog);
    this.spinner = injector.get<NgxSpinnerService>(NgxSpinnerService);
    this.datepipe = injector.get<DatePipe>(DatePipe);
    this.location = injector.get<Location>(Location);
    this.renderer = injector.get<Renderer2>(Renderer2);
  }

  ngOnInit(): void {
    this.subscriptionRouting = this._Activatedroute.paramMap.subscribe(
      (params) => {
        const currentUrl = this._Activatedroute.snapshot['_routerState'].url;

        if (currentUrl.includes(RoutingPath.AddRecurringBill)) {
          this.moduleId = Modules.RecurringBill;
          this.moduleName = ModuleName.RecurringBill;
        } else {
          this.moduleId = Modules.RecurringInvoice;
          this.moduleName = ModuleName.RecurringInvoice;
        }

        if (params.keys.length > 0) {
          this.recurringId = atob(params.get('id')!) as unknown as Guid;
          this.editRecurringData();
        } else {
          this.getRecurringNumber(this.moduleId);
        }
      }
    );
  }

  getRecurringNumber(moduleId): void {
    this.store.dispatch(new GetRecurringNumber(moduleId)).subscribe((res) => {
      res.recurring.recurringNo !== null
        ? this.recurringDetails.recurringForm.controls.recurringNo.disable()
        : this.recurringDetails.recurringForm.controls.recurringNo.enable();
      this.recurringDetails.recurringForm.controls.recurringNo.setValue(
        res.recurring.recurringNo
      );
    });
  }

  editRecurringData(): void {
    this.store
      .dispatch(new GetDataByRecurringModuleId(this.recurringId))
      .subscribe((res) => {
        this.recurringDetails.recurringForm.markAsUntouched();
        this.productDetails.formProductDetail.markAsUntouched();

        this.recurringDetails.isReadOnly = true;
        this.triggerEditData.next(res.recurring.recurringData);
        this.triggereEditProductData.next(res.recurring.recurringData.items);
      });
  }

  showSideListAction(val: boolean): void {
    this.isShowSideListAction = val;
  }

  toggleSideList(val: boolean): void {
    this.istoggleSideList = !this.istoggleSideList;
  }

  reloadAutoNumberGenerator(): void {
    this.getRecurringNumber(this.moduleId);
  }

  triggerReloadSideList(): void {
    this.reloadSideList.emit();
  }

  toggleAccordion(): void {
    this.isExpandAll = !this.isExpandAll;
  }

  setHighlightData(isExit: boolean): void {
    this.commonService.setHighlightData(
      this.recurringId,
      isExit,
      this.moduleId === Modules.RecurringInvoice
        ? Modules.RecurringInvoice
        : Modules.RecurringBill,
      this.moduleId === Modules.RecurringInvoice
        ? RoutingPath.AddRecurringInvoice
        : RoutingPath.AddRecurringBill
    );
  }

  onSave(isExit: boolean): void {
    if (this.recurringDetails.recurringForm.invalid) {
      this.commonService.addValidation(
        this.recurringDetails.recurringForm,
        this.renderer
      );
    } else if (this.productDetails.productDetailArray.invalid) {
      this.productDetails.productDetailArray.controls.forEach((x) => {
        (Object as any).values(x.controls).forEach((c) => {
          c.markAsTouched();
        });
      });
    } else {
      if (this.dataSubmit()) {
        this.store
          .dispatch(
            new CreateRecurringModule(this.recurringData, this.moduleId)
          )
          .pipe()
          .subscribe(
            (res) => {
              if (res !== undefined) {
                this.setHighlightData(isExit);

                if (!isExit) {
                  this.onCancel(false);
                  this.reloadSideList.emit();
                } else {
                  this.onCancel(false);
                  this.location.back();
                }
                this.commonService.onSucess(
                  NotificationTextMessage.successMessage
                );
              } else {
                this.commonService.onFailure(
                  NotificationTextMessage.errorMessage
                );
              }
            },
            (err) => {
              this.commonService.onFailure(err.error.Message);
            }
          );
      }
    }
  }

  dataSubmit(): boolean {
    this.spinner.show();
    try {
      this.productItems = new Array<ProductDetailsModel>();

      this.productDetails.productDetailArray?.getRawValue().forEach((x) => {
        const data = this.productDetails.productTypeData.filter(
          (a) => a.name === x.productName
        );
        if (data.length > 0) {
          x.productId = data[0].id;
        }

        this.productItems.push({
          id: x.id,
          productName: x.productName.id === undefined ? x.productName : '',
          productId:
            x.productName.id === undefined
              ? (Guid.EMPTY as unknown as Guid)
              : x.productName.id,
          description: x.description,
          quantity: +x.qty,
          price: +x.price,
          vatRateId: x.vatRate === -1 ? null : x.vatRate,
          vatAmount: +x.vatAmount,
          totalAmount: +x.amount,
        });
      });

      this.recurringData = {
        id: this.recurringId,
        entryNumber:
          this.recurringDetails.recurringForm.controls.recurringNo.value,
        accountId: this.recurringDetails.recurringForm.controls.accountId.value,
        currencyId: this.recurringDetails.recurringForm.controls.currency.value,
        fundId: this.recurringDetails.recurringForm.controls.fundName.value,
        dueTermId:
          this.recurringDetails.recurringForm.controls.dueTermName.value,
        note: this.recurringDetails.recurringForm.controls.notes.value,
        bookAccountId:
          this.recurringDetails.recurringForm.controls.invoiceType.value.id,
        startDate: this.datepipe
          .transform(
            this.recurringDetails.recurringForm.controls.startDate.value,
            'yyyy-MM-dd'
          )
          ?.toString(),
        endDate: this.datepipe
          .transform(
            this.recurringDetails.recurringForm.controls.endDate.value,
            'yyyy-MM-dd'
          )
          ?.toString(),

        maxNumOfOccurrences:
          +this.recurringDetails.recurringForm.controls.maxNumOfOccurrences
            .value,
        recurringTypeId:
          this.recurringDetails.recurringForm.controls.recurringType.value,
        dayOfWeek: this.recurringDetails.recurringForm.controls.dayOfWeek.value,
        dayOfMonth:
          this.recurringDetails.recurringForm.controls.dayOfMonth.value,
        weekOfMonth:
          this.recurringDetails.recurringForm.controls.monthOfYear.value,
        monthOfYear:
          this.recurringDetails.recurringForm.controls.monthOfYear.value,

        separationCount:
          +this.recurringDetails.recurringForm.controls.separationCount.value,
        recurringEndTypeId:
          this.recurringDetails.recurringForm.controls.scheduleType.value,
        subRecurringTypeId:
          this.recurringDetails.recurringForm.controls.scheduleSubPeriod.value,
        items: this.productItems,
      };
    } catch (error) {
      this.spinner.hide();
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  onCancel(isCancelClick: boolean): void {
    this.commonService.isInitialValueChange = false;
    if (isCancelClick && !this.commonService.isEmpty(this.invoiceId)) {
      this.editRecurringData();
    } else {
      this.invoiceId = Guid.EMPTY as unknown as Guid;
      this.recurringDetails.ngOnInit();
      this.productDetails.ngOnInit();
      this.getRecurringNumber(this.moduleId);
    }
  }

  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }
}
